import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

type DisclaimerBannerProps = {
  variant?: 'default' | 'compact';
  className?: string;
};

export default function DisclaimerBanner({
  variant = 'default',
  className,
}: DisclaimerBannerProps) {
  const compact = variant === 'compact';

  return (
    <div
      role="alert"
      aria-labelledby="legal-disclaimer-title"
      className={cn(
        'w-full rounded-xl border border-primary/25 bg-primary/5',
        compact ? 'px-3 py-2.5' : 'px-4 py-4 md:px-5 md:py-5',
        className
      )}
    >
      <div className={cn('flex', compact ? 'gap-2.5' : 'gap-3 md:gap-4')}>
        <div className="shrink-0 pt-0.5">
          <AlertTriangle
            className={cn('text-primary', compact ? 'size-4' : 'size-6')}
            aria-hidden
          />
        </div>
        <div className={cn('min-w-0 flex-1', compact ? 'space-y-0.5' : 'space-y-2')}>
          <h3
            id="legal-disclaimer-title"
            className={cn(
              'font-semibold text-foreground',
              compact ? 'text-xs font-outfit' : 'text-base md:text-lg'
            )}
          >
            {compact ? 'Legal disclaimer' : 'Important legal disclaimer'}
          </h3>
          <p
            className={cn(
              'text-muted-foreground leading-snug text-pretty',
              compact ? 'text-xs' : 'text-base leading-relaxed'
            )}
          >
            {compact ? (
              <>
                Informational only — not legal advice; no lawyer-client relationship. Consult a
                qualified Malaysian advocate &amp; solicitor for advice about your situation.
              </>
            ) : (
              <>
                MyLegalAI is a static archive of{' '}
                <span className="font-medium text-foreground">general educational material</span>{' '}
                about Malaysia. It is{' '}
                <span className="font-medium text-foreground">not professional legal advice</span>,
                and no lawyer-client relationship is created.
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
